
import React, { useState, useEffect, Component } from "react";
import {Link} from "react-router-dom"
import PaymentBg from "../images/payments.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import Download from "../images/downloadicon.png";
import Check from "../images/check.png";
import { useParams } from "react-router-dom";
import arrowUp from "../images/arrow-up.png";
import arrowRight from "../images/arrow.png"
import "./funds.css";
import Footer from "./footer";
import AOS from 'aos';

const Funds = () => {

   window.scrollTo(0, 0)

   
  const [active, setActive] = useState("General FAQs");
  const [fundI, setFundI] = useState("");
  const [fundII, setFundII] = useState("");
  const [fundIII, setFundIII] = useState("");
  const [fundIV, setFundIV] = useState("");
  const [fundV, setFundV] = useState("");
  const [fundVI, setFundVI] = useState("");
  const [fundVIRSA, setFundVIRSA] = useState("");



  const today = new Date();
  let formatedDate = today.toLocaleDateString('en-US', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })

 

 
 window.scrollTo(0, 0)
const baseUrl = 'https://mapps.leadway-pensure.com/PensureWebsiteAPI/WebData/UnitPrice';
const url = new URL(baseUrl);

// Add query params to the URL
url.searchParams.append('clientId', '9dy8earw04r09wjefsdp90zsjs');



async function unitPrices(){


    const priceUpdate = await fetch(url, { 
    method:"POST",
    headers:{
      "content-type":"application/JSON"
    }
  })

   .then(response => response.json())
   .then(response => {
     console.log(response)

     setFundI(response.Data.Fund1UnitPrice)
     setFundII(response.Data.Fund2UnitPrice)
     setFundIII(response.Data.Fund3UnitPrice)
     setFundIV(response.Data.Fund4UnitPrice)
     setFundV(response.Data.Fund5UnitPrice)
     setFundVIRSA(response.Data.Fund6RSA)
     setFundVI(response.Data.Fund6RF)

     

 


  })

}

       useEffect( () => {
                 AOS.init({
                    offset: 0,
                    duration: 1000,
                    once: true
             });
                              
                                  
             }, [])



useEffect( () => {
unitPrices()
      
      }, [])  
  return (
    <>
   

      <div
        id="faq-types-section"
        class="containeer d-flex align-items-start   mt-4"
        style={{ backgroundColor: "none" }}
      >

        <div className="flex-1 p-6 full-width ">
     
                 <div className="faq-type-content pb-5">
                    <h2 className="payment-h2" data-aos="fade-up" data-aos-delay="200"> RSA Fund Prices </h2>
              <p id="crd-p" className="grey-p" data-aos="fade-up" data-aos-delay="200">
                {" "}
               Value Date for {formatedDate}
              </p>
                <hr className="btm-bdr-rma" />
                
                 </div>


                         <div className="plain-cont">
        <div id="mobile-view" className="row d-flex justify-content-between text-center no-padding">
        
             <div id="mobile-view" className="d-flex justify-content-betwee no-padding" >
             
                <div className="card funds-crd text-start" data-aos="zoom-in" data-aos-delay="200">
                  <figure className="compact-settings-rsa-works" >
                    <p className="pb-3 fund-price-heading "  data-aos="fade-up" data-aos-delay="200"> 
                          RSA FUND I
                    </p>
                    <figcaption>
                    <h4 className="card-subtitle pb-4 fund-price-figure" data-aos="zoom-in" data-aos-delay="200"> <span className="naira"> &#8358;  </span>  {fundI} <span class="badge text-bg-success sizePlacement"> <img src={arrowUp} /> 33.3% </span> </h4>
                  
                      <Link className="no-decoration orange-p-funds" to="/fund-price/history/fund1"  data-aos="fade-up" data-aos-delay="200"> 
                        View History
                              <img src={arrowRight} className="padding-left" />
                      </Link>
                    
                
               
                    </figcaption>
                
                  </figure>
                </div>

   
                   
                <div className="card funds-crd text-start" data-aos="zoom-in" data-aos-delay="200">
                  <figure className="compact-settings-rsa-works">
                    <p className="pb-3 fund-price-heading"  data-aos="fade-up" data-aos-delay="200"> 
                          RSA FUND II
                    </p>
                    <figcaption>
                    <h4 className="card-subtitle pb-4 fund-price-figure" data-aos="fade-up" data-aos-delay="200"> <span className="naira"> &#8358;  </span>  {fundII}  <span class="badge text-bg-success sizePlacement"> <img src={arrowUp} /> 33.3% </span> </h4>
                   <Link className="no-decoration orange-p-funds" to="/fund-price/history/fund2" data-aos="fade-up" data-aos-delay="200"> 
                        View History
                              <img src={arrowRight} className="padding-left" />
                      </Link>
                    </figcaption>
                
                  </figure>
                </div>

                   
            <div className="card funds-crd text-start" data-aos="zoom-in" data-aos-delay="200">
                  <figure className="compact-settings-rsa-works" >
                    <p className="pb-3 fund-price-heading" data-aos="fade-up" data-aos-delay="200"> 
                          RSA FUND III
                    </p>
                    <figcaption>
                    <h4 className="card-subtitle pb-4 fund-price-figure" data-aos="fade-up" data-aos-delay="200"> <span className="naira"> &#8358;  </span>  {fundIII} <span class="badge text-bg-success sizePlacement"> <img src={arrowUp} /> 33.3% </span> </h4>
                  <Link className="no-decoration orange-p-funds" to="/fund-price/history/fund3" data-aos="fade-up" data-aos-delay="200"> 
                        View History
                              <img src={arrowRight} className="padding-left" />
                      </Link>
                    </figcaption>
                
                  </figure>
                </div>



                    <div className="card funds-crd text-start" data-aos="zoom-in" data-aos-delay="200">
                  <figure className="compact-settings-rsa-works">
                    <p className="pb-3 fund-price-heading" data-aos="fade-up" data-aos-delay="200"> 
                          RSA FUND IV
                    </p>
                    <figcaption>
                    <h4 className="card-subtitle pb-4 fund-price-figure" data-aos="fade-up" data-aos-delay="200"> <span className="naira"> &#8358;  </span>  {fundIV}  <span class="badge text-bg-success sizePlacement"> <img src={arrowUp} /> 33.3% </span> </h4>
                    <Link className="no-decoration orange-p-funds" to="/fund-price/history/fund4" data-aos="fade-up" data-aos-delay="200"> 
                        View History
                    <img src={arrowRight} className="padding-left" />
                    </Link>
                    </figcaption>
                
                  </figure>
                </div>


            
             
              
             
          </div>

                       <div id="mobile-view" className="d-flex pt-5 card-container no-padding" >
             
                <div className="card funds-crd-b text-start">
                  <figure className="compact-settings-rsa-works">
                    <p className="pb-3 fund-price-heading" > 
                          RSA FUND V
                    </p>
                    <figcaption>
                    <h4 className="card-subtitle pb-4 fund-price-figure"> <span className="naira"> &#8358;  </span>  {fundV}  <span class="badge text-bg-success sizePlacement"> <img src={arrowUp} /> 33.3% </span> </h4>
                  <Link className="no-decoration orange-p-funds" to="/fund-price/history/fund5"> 
                        View History
                  <img src={arrowRight} className="padding-left" />
                      </Link>
                    </figcaption>
                
                  </figure>
                </div>

   
                   
                <div className="card funds-crd-b text-start" >
                  <figure className="compact-settings-rsa-works">
                    <p className="pb-3 fund-price-heading" > 
                          RSA FUND VI (Active)
                    </p>
                    <figcaption>
                    <h4 className="card-subtitle pb-4 fund-price-figure" > <span className="naira"> &#8358;  </span>  {fundVIRSA}  <span class="badge text-bg-success sizePlacement"> <img src={arrowUp} /> 33.3% </span> </h4>
                      <Link className="no-decoration orange-p-funds" to="/fund-price/history/fund6"> 
                        View History
                      <img src={arrowRight} className="padding-left" />
                      </Link>
                    </figcaption>
                
                  </figure>
                </div>

                         
                <div className="card funds-crd-b text-start">
                  <figure className="compact-settings-rsa-works" >
                    <p className="pb-3 fund-price-heading" > 
                          RSA FUND VI (Retiree)
                    </p>
                    <figcaption>
                    <h4 className="card-subtitle pb-4 fund-price-figure"> <span className="naira"> &#8358;  </span>  {fundVI} <span class="badge text-bg-success sizePlacement"> <img src={arrowUp} /> 33.3% </span> </h4>
                      <Link className="no-decoration orange-p-funds" to="/fund-price/history/fund6-retiree"> 
                        View History
                      <img src={arrowRight} className="padding-left" />
                      </Link>
                    </figcaption>
                
                  </figure>
                </div>

                   
    


          


            
             
              
             
          </div>
         
         
        </div>
      </div>
    
   
             </div>
      </div>
         <Footer/>
           <div className='height'> 

              </div>
    </>
  );
};

export default Funds;
